<template>
    <div class="con">
        <div class="one">
            <div class="main">
                <div class="left">
                    <img src="../assets/ycb/footLogo.png" alt="">
                </div>
                <div class="center">
                    <div class="ap">
                        <span>慈华臻品</span>
                        <span>产品中心</span>
                        <span>新闻资讯</span>
                        <span>联系我们</span>
                        <div class="aImgs">
                            <i class="iconfont icon-douyin-01"></i>
                            <i class="iconfont icon-Facebook"></i>
                            <i class="iconfont icon-xinlang"></i>
                            <i class="iconfont icon-weixin1"></i>
                        </div>
                    </div>
                    <div class="aLists">
                        <div class="list" v-for="(item,index) in list" :key="index">
                            <div class="item" v-for="(i,idx) in item.con" :key="idx" @click="goto(index,idx,i.id)">
                                                            {{i.classname ? i.classname:i}}
                            </div>
                        </div>
                        <div class="code">
                            <img src="../assets/ycb/code.png" alt="">
                        </div>
                    </div>
                    <div class="info">
                        <!-- <div class="item">
                            <p>Call phone</p>
                            <p>400-008-5500</p>
                        </div>
                        <div class="item">
                            <p>Mobile QQ</p>
                            <p>400-008-5500</p>
                        </div>
                        <div class="item">
                            <p>WeChat</p>
                            <p>400-008-5500</p>
                        </div> -->
                        <div class="input">
                            <input type="text" v-model="form.content">
                            <span @click="submitForm">Enter</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="two">
            <div class="main">
                <p>
                    © {{year}}  CHZP . Inc.- 保留所有权利 www.cncihua.com 宁波慈华臻品有限公司
                    <a href="https://beian.miit.gov.cn/" target="_blank">
                        浙ICP备17021954号-1
                    </a>
                </p>
                <a href="https://www.sansg.com/" target="_blank">
                    Brand Service Provider:三盛网络
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {getFooter} from '../util/lang'
    import  qs from 'qs'
    export default {
        name: "foot",
        data(){
            return{
                year:'',
                form:{
                    content:''
                },
                list:[
                    {con:[
                            "品牌介绍",
                            "品牌文化",
                            "发展历程",
                            "荣誉资质"
                        ]},
                    {con:[]},
                    {con:[]},
                    {con:[
                            "在线留言",
                            "联系我们"
                        ]}
                ]
            }
        },
        mounted(){
            let date = new Date();
            let y = date.getFullYear();
            this.year=y
            this.$nextTick(()=>{
                this.getNav()
            })
        },
        methods:{
            submitForm() {
                if(this.form.content==''){
                    this.$notify.info({
                        title: '提示',
                        message: '请将信息填写完整哦'
                    });
                }else{
                    this.$nextTick(()=>{
                        const url ='/common/Form.php'
                        this.$axios.post(url,
                            qs.stringify(
                                this.form
                            )
                        ).then(res => {
                            if(res.data.code===200){
                                this.$notify({
                                    title: '成功',
                                    message: '您的信息已经成功提交',
                                    type: 'success'
                                });
                                this.form={
                                    content:''
                                }
                            }
                        }).catch(res=>{
                            this.$notify.error({
                                title: '错误',
                                message: '提交失败'
                            });
                        })
                    })
                }
            },
            getNav(){
                const url = `${getFooter()}`
                this.$axios.get(url).then(res => {
                    console.log(res.data)
                    this.list[1].con=res.data.products_type
                    this.list[2].con=res.data.news_type
                   console.log(this.list)
                })
            },
            goto(n,i,id){
                if(n===0){
                    const link=`/about.html?index=${i}`
                    window.open(link,'_self')
                }else if(n===1){
                    const link=`/pro.html?id=${id}`
                    window.open(link,'_self')
                }else if(n===2){
                    const link=`/news.html?id=${id}`
                    window.open(link,'_self')
                }else if(n===3){
                    const link='/contact.html'
                    window.open(link,'_self')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        background-color: #1D1D1D;
        .one{
            width:100%;
            .main{
                width:80%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                margin: 0 auto;
                padding: 40px 0;
                padding-bottom: 20px;
                .left{
                    width:10%;
                }
                .center{
                    width:80%;
                    .ap{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        border-bottom: 1px solid rgba(255,255,255,.1);
                        padding: 20px 0;
                        position: relative;
                        span{
                            font-family: "SOURCEHANSANSCN-LIGHT";
                            color:white;
                            display: inline-block;
                            width:20%;
                            text-align: center;
                        }
                        .aImgs{
                            position: absolute;
                            right:0;
                            top:30px;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            i{
                                color:#666666;
                                font-size: 20px;
                                cursor: pointer;
                                transition: all 600ms;
                              margin-right: 15px;
                                display: inline-block;
                                height:20px;
                                width:20px;
                                &:hover{
                                    color:#F7C66B;
                                }
                            }
                        }
                    }
                    .aLists{
                        width:100%;
                        display: flex;
                        flex-direction: row;position: relative;
                        margin: 10px 0;
                        .list{
                            width:20%;
                            .item{
                                color:#999999;
                                font-size: 14px;
                                margin-top: 15px;
                                cursor: pointer;
                                font-family: "SOURCEHANSANSCN-LIGHT";
                                transition: all 600ms;
                                text-transform: capitalize;
                                text-align: center;
                                &:hover{
                                    color:#F7C66B;
                                }
                            }
                        }
                        .code{
                            position: absolute;
                            right:0;
                            border:1px solid rgba(255,255,255,.1);
                            top:10px;
                            padding: 5px;
                            img{
                                max-width: 100%;
                                display: block;
                                object-fit: contain;
                            }
                        }
                    }
                    .info{
                        width:77%;
                        display: flex;
                        flex-direction: row;
                        margin: 40px 0;
                        justify-content: center;
                        .item{
                            width:15%;
                            margin-left: 7%;
                            p:nth-child(1){
                                font-size: 14px;
                                color:rgba(255,255,255,1);
                                font-family: "it";
                            }
                            p:nth-child(2){
                                font-family: "it";
                                color:rgba(255,255,255,.5);
                                font-size: 20px;
                                margin-top: 10px;
                            }
                        }
                        .input{
                            width:40%;
                            height:36px;
                            border:1px solid rgba(255,255,255,.1);
                            position: relative;
                            margin-left: 5%;
                            input{
                                background-color: transparent;
                                height:100%;
                                width:100%;
                                border: none;
                                color:white;
                            }
                            input:focus{
                                outline: none;
                            }
                            span{
                                display: inline-block;
                                right:0;
                                top:0;
                                width:84px;
                                height:36px;
                                background:rgba(247,198,107,1);
                                position: absolute;
                                text-align: center;
                                line-height: 36px;
                                font-size: 14px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
        .two{
            width:100%;
            .main{
                width:80%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin: 0 auto;
                padding:25px 0;
                border-top: 1px solid rgba(74,74,74,.32);
                a,p{
                    font-size: 14px;
                    color:#939393;
                    font-family: "SOURCEHANSANSCN-LIGHT";
                }
                a{
                    transition: all 600ms;
                    &:hover{
                        color:#F7C66B;
                    }
                }
            }
        }
        @media screen and (max-width: 1440px) {
            .one{
                .main{
                    width:90%;
                }
            }
            .two{
                .main{
                    width:90%;
                }
            }

        }
        @media screen and (max-width: 1000px){
            .one{
                .main{
                    .left{
                        width:100%;
                        text-align: center;
                    }
                    .center{
                        display: none;
                    }
                }
            }
            .two{
                .main{
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    p{
                        text-align: center;
                        line-height: 30px;
                    }
                }
            }
        }
    }
</style>
